import { queryMatches, substituteCharacters } from './utils';
function matchesAccount(account, query) {
  if (account.folio.toString() === query) {
    return true;
  }
  return queryMatches(account.name, query);
}
function matchesTitle(title, query) {
  return queryMatches(title, query);
}
function matchesSynonym(synonyms, query) {
  return synonyms.some(synonym => queryMatches(synonym, query));
}
export function filterSubcategories(subcategories, query) {
  const substitutedQuery = substituteCharacters(query);
  return subcategories.filter(({
    account,
    title,
    synonyms
  }) => {
    return matchesAccount(account, substitutedQuery) || matchesTitle(title.toLowerCase(), substitutedQuery) || matchesSynonym(synonyms, substitutedQuery);
  });
}
//# sourceMappingURL=filter-subcategories.js.map